import { ApiBase } from "../../../core/api-base";
import { z } from "zod";
import { UpsertBrandRecommendBody } from "../../../api/generated/brands.zod";

type UpsertBrandRecommendPayload = z.infer<typeof UpsertBrandRecommendBody>;

export class BrandRecommendApi extends ApiBase {
    public static async getMeta(brandId: number): Promise<Response> {
        return await super.apiGet(`/api/v1/brands/${brandId}/recommends`, { noSpinner: true });
    }

    public static async upsert(brandId: number, rank: number | null): Promise<Response> {
        const payload: UpsertBrandRecommendPayload = { rank: rank === null ? null : Number(rank) };
        return await super.apiPost(`/api/v1/brands/${brandId}/recommends`, payload, { noSpinner: true });
    }

    public static async remove(brandId: number): Promise<Response> {
        return await super.apiDelete(`/api/v1/brands/${brandId}/recommends`, { noSpinner: true });
    }

    public static async clearAll(): Promise<Response> {
        return await super.apiDelete("/api/v1/brands/recommends/clear", { noSpinner: true });
    }
}
